module.exports = __webpack_public_path__ + "img/Coin-stack.3b30507b.svg";